import { Form } from 'react-bootstrap';
import EditStringWithHelp from 'components/edit/EditStringWithHelp';

type Props = {
  selectedValue?: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ScheduleStartTime = ({ selectedValue, onChange }: Props) => (
  <Form.Group className="mb-2" controlId="formScheduleStartTime">
    <Form.Label>Schedule Start Time</Form.Label>
    <EditStringWithHelp
      name="schedule_start_time"
      value={selectedValue ?? ''}
      placeholder="e.g. 08:30 or =Time.now()"
      onChange={onChange}
      helpTitle="Schedule start time help"
    >
      <p className="mb-2">Accepts any of the following formats:</p>
      <ul className="mb-2 ps-3">
        <li>
          <strong>Time of day</strong> — <code>HH:MM</code>, e.g. <code>08:30</code>.
        </li>
        <li>
          <strong>JEXL expression</strong> — prefixed with <code>=</code>, e.g. <code>=Time.now()</code>. Must evaluate to an epoch-ms number or an ISO date
          string.
        </li>
        <li>
          <strong>Date expression</strong> — applied relative to the scheduled start, e.g. <code>add 1 day</code> or <code>truncate day</code>.
        </li>
        <li>
          <strong>Numeric timestamp</strong> — a millisecond offset from midnight (value &lt; 86&nbsp;400&nbsp;000) or an absolute epoch-ms timestamp (value
          &ge; 86&nbsp;400&nbsp;000).
        </li>
      </ul>
      <p className="mb-0">Expressions are evaluated in the node&apos;s configured timezone.</p>
    </EditStringWithHelp>
  </Form.Group>
);

export default ScheduleStartTime;
